$(document).on("click", ".limited_wrraper .addtocart .button", function (e) {
    e.preventDefault();
 if ($(this).hasClass("disabled")) return;
 $(this).addClass("disabled").css({
        "pointer-events": "none",
        "opacity": "0.5"
    });
    var $button = $(this); // Store reference to the clicked button 
    var productid = $button.parents(".addtocart").attr("data_var");
    localStorage.setItem("limitedWrapId", productid);
    //////////// if product is already added //////////////////
    // Step 1: Fetch current cart data
    
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function (cart) {
        // Step 2: Check if variant_id already exists in the cart
        var isAlreadyInCart = cart.items.some(item => item.variant_id == productid);
  
        if (isAlreadyInCart) {
          console.log(`Variant ID ${productid} is already in the cart. Skipping add.`);
          
          // Optionally display a message or prevent further actions
          //alert("This item is already in your cart.");
          return;  // Stop execution if variant is already in the cart
        }
      }
    });
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: productid,
        quantity: 1,
      },
      dataType: 'json',
      success: function (productid2) {
        console.log('productid2---->>>',productid2);
        jQuery.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function (cart22) {
  
            if ($(".UpsellWrapperCard").hasClass("active")) {
            } else {
              setTimeout(function () {
                $(".UpsellWrapperCard").removeClass("active");
              }, 800);
  
            }
             $(this).attr("disabled",true)
            fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
              const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
              const bubble = document.querySelector('#cart-icon-bubble');
              bubble.innerHTML = bubbleHTML;
  
  
            })
            fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
              const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
              const drawer = document.querySelector('cart-drawer');
              drawer.innerHTML = newHTML;
              var newboxid = localStorage.getItem('giftBoxVarid');
              // if (newboxid) {
              //   Correct way to disable the button
              //   $(".gift_popup-addtocart button").prop("disabled", true);
              //   Remove the entire div if needed
              //   $(".gift_popup-addtocart").remove();
              // }
  
            });
  
            $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
            $(".RQCartDRawerExecutionmWp ").addClass("active");
            $("body").removeClass("gift_popup_active");
            $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
  
            setTimeout(function () {
              Smile.ready().then(smileInstance => {
                $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
              }).catch(err => {
                // An error has occurred will initializing smile.
              });
              if (document.querySelectorAll('.new_custom_drawer_products').length > 0) {
                function FounderCookie(cookieName) {
                  const cookies = document.cookie.split(';');
                  for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.startsWith(cookieName + '=')) {
                      return true;
                    }
                  }
                  return false;
                }
  
                function startTimer(duration, display) {
                  console.log(123456789);
                  var timer = duration, minutes, seconds;
                  setInterval(function () {
  
                    minutes = parseInt(timer / 60, 10)
                    seconds = parseInt(timer % 60, 10);
                    // minutes = minutes < 10 ? "0" + minutes : minutes;
                    // seconds = seconds < 10 ? "0" + seconds : seconds;
  
                    var minutes_fst = minutes.toString().split("").map(Number)[0];
                    var minutes_scd = minutes.toString().split("").map(Number)[1];
  
                    var seconds_fst = seconds.toString().split("").map(Number)[0];
                    var seconds_scd = seconds.toString().split("").map(Number)[1];
  
                    if (typeof minutes_scd !== 'undefined') {
                      display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
                    } else {
                      display.querySelector('#timer-hours').innerHTML = `<span>0</span><span>${minutes_fst}</span>`;
                    }
  
                    if (typeof seconds_scd !== 'undefined') {
                      display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
                    } else {
                      display.querySelector('#timer-minutes').innerHTML = `<span>0</span><span>${seconds_fst}</span>`;
                    }
  
  
                    if (FounderCookie('offerInvalid')) { } else {
                      if (--timer < 0) {
                        const expirationDate = new Date();
                        expirationDate.setDate(expirationDate.getDate() + 7);
                        document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                      }
                    }
  
                    if (FounderCookie('offerInvalid')) {
                      if (document.querySelector('.drawer_timer_outer-wrapp')) {
                        document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                      }
                      if (document.querySelector('.new_custom_drawer_products')) {
                        document.querySelector('.new_custom_drawer_products').style.display = 'none';
                      }
                      window.localStorage.removeItem("seconds")
                      window.localStorage.removeItem("minutes")
                    } else {
                      if (document.querySelector('.drawer_timer_outer-wrapp')) {
                        document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                      }
                      if (document.querySelector('.new_custom_drawer_products')) {
                        document.querySelector('.new_custom_drawer_products').style.display = 'block';
                      }
                      window.localStorage.setItem("seconds", seconds)
                      window.localStorage.setItem("minutes", minutes)
                    }
  
  
  
                  }, 1000);
                }
  
                var sec = parseInt(window.localStorage.getItem("seconds"));
                var min = parseInt(window.localStorage.getItem("minutes"));
  
                if (FounderCookie('offerInvalid')) {
                  if (document.querySelector('.drawer_timer_outer-wrapp')) {
                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                  }
                  if (document.querySelector('.new_custom_drawer_products')) {
                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                  }
                  window.localStorage.removeItem("seconds")
                  window.localStorage.removeItem("minutes")
                } else {
                  if (document.querySelector('.drawer_timer_outer-wrapp')) {
                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                  }
                  if (document.querySelector('.new_custom_drawer_products')) {
                    document.querySelector('.new_custom_drawer_products').style.display = 'block';
                  }
                }
  
                if (parseInt(min * sec)) {
                  var fiveMinutes = (parseInt(min * 60) + sec);
                } else {
                  var fiveMinutes = 60 * 30;
                }
  
                var display = document.querySelector('#timer-box');
                if (parseInt(min) == 0) {
                  console.log(1234567);
                  if (document.querySelector('.drawer_timer_outer-wrapp')) {
                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                  }
                  if (document.querySelector('.new_custom_drawer_products')) {
                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                  }
                  window.localStorage.removeItem("seconds")
                  window.localStorage.removeItem("minutes")
                  const expirationDate = new Date();
                  expirationDate.setDate(expirationDate.getDate() + 7);
                  document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                } else {
                  startTimer(fiveMinutes, display);
                }
  
              } else {
                document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
              }
            }, 800);
          },
        });
      },
    });
    
  });